import { Card } from 'react-bootstrap';

export function StatisticsExplanation() {
  return (
    <Card>
      <Card.Body>
        <h5>Statistics Explanation</h5>
        <ul>
          <li>
            <strong>Appearances:</strong> Total number of Ryd-Her Cup team competitions played
          </li>
          <li>
            <strong>Points:</strong> Total points earned across all competitions / Total available points
          </li>
          <li>
            <strong>Points %:</strong> Percentage of available points earned (Points Scored / Available Points × 100)
          </li>
          <li>
            <strong>USA / Europe:</strong> Number of Ryd-Her Cup appearances for each team, number of times the team won
            the cup, and points breakdown (scored / available)
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
}
